import { queryOptions, useQuery } from '@tanstack/react-query';
import { AdaptivePlannerTimelineApi } from '@/lib/api/adaptive-planner/timeline';
import { adaptivePlannerQueryKeys } from '@/lib/query-keys/adaptivePlanner';

export const getTimelineItemsDataSetQueryOptions = ({
  planId,
  scenarioId,
  enabled = true,
}: {
  planId: number;
  scenarioId: number;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: adaptivePlannerQueryKeys.timeline.dataSet({
      planId,
      scenarioId,
    }),
    queryFn: () =>
      AdaptivePlannerTimelineApi.getTimelineDataSet({
        planId,
        scenarioId,
      }),
    enabled,
    placeholderData: (previousData) => previousData,
  });

export const useGetTimelineItemsDataSetQuery = ({
  planId,
  scenarioId,
  enabled = true,
}: {
  planId: number;
  scenarioId: number;
  enabled?: boolean;
}) => {
  return useQuery(getTimelineItemsDataSetQueryOptions({ planId, scenarioId, enabled }));
};
